import { baseMusculoskeletal, baseMusculoskeletalLocationEntry } from '../validations/oasis-sections/section-g';
const shape = baseMusculoskeletal.shape;
const locationShape = baseMusculoskeletalLocationEntry.shape;
export const musculoskeletalWnlFields = [{ key: 'wnl', field: shape.wnl }];
export const mainFields = [
    { key: 'musculoskeletalGait', field: shape.musculoskeletalGait },
    { key: 'musculoskeletalStrength', field: shape.musculoskeletalStrength },
    { key: 'ambulatoryAid', field: shape.ambulatoryAid },
    { key: 'weightBearingRestrictions', field: shape.weightBearingRestrictions },
];
export const aftercareFields = [
    { key: 'aftercareHipReplacement', field: shape.aftercareHipReplacement, variant: 'tags' },
    { key: 'aftercareKneeReplacement', field: shape.aftercareKneeReplacement, variant: 'tags' },
    { key: 'autoimmuneCondition', field: shape.autoimmuneCondition, variant: 'tags' },
    { key: 'findings', field: shape.findings, variant: 'tags' },
];
export const romFields = [
    { key: 'lueROM', field: shape.lueROM },
    { key: 'rueROM', field: shape.rueROM },
    { key: 'lleROM', field: shape.lleROM },
    { key: 'rleROM', field: shape.rleROM },
];
export const locationFields = [
    { key: 'location', field: locationShape.location },
    { key: 'type', field: locationShape.type },
];
export const musculoskeletalNarrativeFields = [
    { key: 'clinicalNarrative', field: shape.clinicalNarrative },
];
